import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/dashboard/dashboard.component').then(m => m.DashboardComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard-home/dashboard-home.component').then(m => m.DashboardHomeComponent)
      },
      {
        path: 'actes-medicaux',
        loadChildren: () => import('./features/medicals-actes/medicals-actes.routes').then(m => m.MEDICALS_ACTES_ROUTES)
      },
      {
        path: 'ipm',
        loadChildren: () => import('./features/ipm/ipm.route').then(m => m.IPM_ROUTES)
      },
      {
        path: 'structure',
        loadChildren: () => import('./features/structure/structure.route').then(m => m.STRUCTURE_ROUTES)
      },
      {
        path: 'entreprise',
        loadChildren: () => import('./features/entreprise/entreprise.route').then(m => m.ENTREPRISE_ROUTES)
      },
      {
        path: 'produits',
        loadChildren: () => import('./features/products/product.route').then(m => m.PRODUCT_ROUTES)
      },
      {
        path: 'drugs',
        loadChildren: () => import('./features/drugs/drug.route').then(m => m.DRUG_ROUTES)
      },
      {
        path: 'adresse',
        loadChildren: () => import('./features/adresses/address.route').then(m => m.ADDRESS_ROUTES)
      },
      {
        path: 'patient',
        loadChildren: () => import('./features/patient/patient.route').then(m => m.PATIENT_ROUTES)
      },
      {
        path: 'invoice',
        loadChildren: () => import('./features/invoice/invoice.routes').then(m => m.INVOICE_ROUTES)
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/user.routes').then(m => m.USER_ROUTES)
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent)
      }
    ]
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.route').then(m => m.AUTH_ROUTES)
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
